
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workingolf/career-services",
      function () {
        return require("private-next-pages/workingolf/career-services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workingolf/career-services"])
      });
    }
  